import Home from '../pages/home_screen';
import see_all from '../pages/see_all';
import Detail from '../pages/detail/Detail(not_use_right_now)';
import PurchaseSubscription from '../pages/subscription/PurchaseSubscription';
import MusicDetail from '../pages/detail/details/MusicDetail';
import AlbumDetail from '../pages/detail/details/AlbumDetail';
import ArtistDetail from '../pages/detail/details/ArtistDetail';
import PlaylistDetail from '../pages/detail/details/PlaylistDetail';
import Search from '../pages/search/Search';

/** artist */
import ArtistSong from '../pages/artist_song';
import ArtistAlbum from '../pages/artist_album';

/*** Audio Routes ***/
import AudioHomeScreen from '../pages/audio/home_screen';
import AudioSeeAll from '../pages/audio/see_all';
import AudioBookBySeries from '../pages/audio/book_by_series_screen';
import AudioBookByDetail from '../pages/audio/book_by_detail_screen';
import AudioCategoryList from '../pages/audio/category_list';
import AudioBookByCategoryScreen from '../pages/audio/book_by_category_screen';
import AudioAllPublishersScreen from '../pages/audio/all_publishers_screen';
import AudioBookByAuthorScreen from '../pages/audio/book_by_author_screen';
import PurchasedBookScreen from '../pages/audio/purchased_book_screen';

/*** T&C Routes ***/
import TermsAndCondition from '../pages/terms_and_conditions';
import FAQs from '../pages/faqs';

/*** My Account Routes ***/
import MyAccount from '../pages/my_account_screen';
import { Navigate } from 'react-router';
import AudiobookCollection from '../pages/audio/book_by_collection_screen';
import AudioBookSearch from '../components/audio/search/AudioBookSearch';
import PaymentScreen from '../components/creditFill';
import OtpVerify from '../pages/subscription/OtpVerify';

const routes = [
    // {
    //   path: '/',
    //   label: 'Home',
    //   component: Home,
    // },
    {
      path: '/',
      element: <Navigate to="/audio" replace />,
    },
    {
      path: 'audio/search',
      label: 'AudioSearch', 
      component: AudioBookSearch,
    },
    {
      path: '/audio',
      label: 'AudioHome',
      component: AudioHomeScreen,
    },
    {
      path: '/music',
      label: 'Home',
      component: Home,
    },
    {
      path: 'music/see_all/:category_id/:category_type',
      label: 'SeeAll', 
      component: see_all,
    },
    {
      path: 'music/search',
      label: 'Search', 
      component: Search,
    },
    {
      path: 'music/detail/songs/:id',
      label: "MusicDetail",
      component: MusicDetail
    },
    {
      path: 'music/detail/album/:id',
      label: "AlbumDetail",
      component: AlbumDetail
    },
    {
      path: 'music/detail/artist/:id',
      label: "ArtistDetail",
      component: ArtistDetail
    },
    {
      path: 'music/detail/playlist/:id',
      label: "PlaylistDetail",
      component: PlaylistDetail
    },
    {
      path: 'music/artist/:artist_id/songs',
      label: "Artist Song",
      component: ArtistSong
    },
    {
      path: 'music/artist/:artist_id/albums',
      label: "Artist Album",
      component: ArtistAlbum
    },
    {
      path: 'audio',
      label: "AudioHome",
      component: AudioHomeScreen
    },
    {
      path: 'audio/see_all/:category_id/:category_type',
      label: 'AudioSeeAll', 
      component: AudioSeeAll,
    },
    {
      path: 'audio/book-series/:item_id',
      label: 'AudioBookBySeries', 
      component: AudioBookBySeries,
    },
    {
      path: 'audio/book-detail/:item_id',
      label: 'AudioBookByDetail', 
      component: AudioBookByDetail,
    },
    {
      path: 'audio/category-list',
      label: 'AudioCategoryList', 
      component: AudioCategoryList,
    },
    {
      path: 'audio/books-by-category/:item_id',
      label: 'AudioBookByCategory', 
      component: AudioBookByCategoryScreen,
    },
    {
      path: 'audio/all-publishers',
      label: 'AudioAllPublishers', 
      component: AudioAllPublishersScreen,
    },
    {
      path: 'audio/books-by-author/:author_id',
      label: 'AudioBookByAuthor', 
      component: AudioBookByAuthorScreen,
    },
    {
      path: 'audio/books-by-collection/:id',
      label: 'AudiobookCollection', 
      component: AudiobookCollection,
    },
    {
      path: 'account/my-account',
      label: 'MyAccount', 
      component: MyAccount,
    },
    {
      path: 'account/purchase_subscription',
      label: 'Subscription', 
      component: PurchaseSubscription,
    },
    {
      path: 'account/t_&_C',
      label: 'Terms and Conditions', 
      component: TermsAndCondition,
    },
    {
      path: 'account/f_a_q',
      label: 'FAQs', 
      component: FAQs,
    },
    {
      path: 'credit-fill',
      label: 'CreditFills', 
      component: PaymentScreen,
    },
    {
      path: 'audio/purchased-books',
      label: 'PurchasedBooks', 
      component: PurchasedBookScreen,
    },
    {
      path: 'audio/subscription/verify',
      label: 'OtoVerify', 
      component: OtpVerify,
    },
  ];

export default routes;